export enum EFontStyle {
    I = 'I',
    B = 'B',
    AT = 'AT',
}
